module.exports = __webpack_public_path__ + "static/media/8.c6399078.jpg";